/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Description_DescInputs */



/**
* | output |
* | --- |
* | "Optional. A short explanation of what this conversation type is about." |
*
* @param {Settings_Template_Description_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_description_desc = /** @type {((inputs?: Settings_Template_Description_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Description_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Optioneel. Leg kort uit waarover dit gesprekstype gaat.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Facultatif. Une courte explication de ce dont parle ce type de conversation.")
	return /** @type {LocalizedString} */ ("Optional. A short explanation of what this conversation type is about.")
});